import { Box } from "@mui/material";
// import { colors } from "../Theme/tokens";
import { useColors } from "../Theme/ColorModeContext";

const MainLayout = ({ children, sx = {} }) => {
  const colors = useColors()
  return (
    <Box
      component="main"
      sx={{
        backgroundColor: colors.background.cardBg,
        width: "100%",
        maxWidth: "1580px",
        margin: "0 auto",
        minHeight: "100vh",
        ...sx, // allow page-level overrides
      }}
    >
      {children}
    </Box>
  );
};

export default MainLayout;
